import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCreationContests } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { creationContestsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfCreativeContestContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const creationContests = useAppSelector(creationContestsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().creationContests });

  const hasData = creationContests.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(creationContests, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Конкурсы" Icon={IconWidgetCreationContests}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCreativeContestContainer;
